/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every formula is written out on the tool page, with worked examples you can reproduce by hand.`)
};

const es_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada fórmula está escrita en la página de la herramienta, con ejemplos resueltos que puedes reproducir a mano.`)
};

const de_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Formel wird auf der Werkzeugseite ausgeschrieben, mit durchgerechneten Beispielen, die du von Hand nachvollziehen kannst.`)
};

const nl_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke formule staat uitgeschreven op de toolpagina, met uitgewerkte voorbeelden die je met de hand kunt reproduceren.`)
};

const fr_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque formule est détaillée sur la page de l’outil, avec des exemples résolus que vous pouvez reproduire à la main.`)
};

const it_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni formula è riportata per esteso nella pagina dello strumento, con esempi svolti che puoi riprodurre a mano.`)
};

const pt_br2_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada fórmula é detalhada na página da ferramenta, com exemplos resolvidos que você pode reproduzir manualmente.`)
};

const pt_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada fórmula está descrita na página da ferramenta, com exemplos resolvidos que pode reproduzir à mão.`)
};

const ja_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての数式はツールページに記載されており、手計算で再現できる解いた例が付いています。`)
};

const zh_about_verify_li1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个公式都在工具页面上完整列出，并附有可手动重现的示例演算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_verify_li1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_verify_li1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_verify_li1", locale)
	if (locale === "en") return en_about_verify_li1(inputs)
	if (locale === "es") return es_about_verify_li1(inputs)
	if (locale === "de") return de_about_verify_li1(inputs)
	if (locale === "nl") return nl_about_verify_li1(inputs)
	if (locale === "fr") return fr_about_verify_li1(inputs)
	if (locale === "it") return it_about_verify_li1(inputs)
	if (locale === "pt-BR") return pt_br2_about_verify_li1(inputs)
	if (locale === "pt") return pt_about_verify_li1(inputs)
	if (locale === "ja") return ja_about_verify_li1(inputs)
	return zh_about_verify_li1(inputs)
};